import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useQueryParams from "./useQueryParams";
var useSort = function () {
    var history = useHistory();
    var _a = useQueryParams(), push = _a.push, initialValues = _a.initialValues;
    var _b = useState({
        field: "name",
        direction: "asc",
    }), state = _b[0], setState = _b[1];
    useEffect(function () {
        if (!initialValues.sort) {
            return;
        }
        var _a = Object.entries(initialValues.sort)[0], field = _a[0], direction = _a[1];
        setState({
            field: field,
            direction: direction,
        });
    }, [history.location.search]);
    var sortBy = function (key) {
        var _a;
        // const params = qs.parse(history.location.search.substring(1))
        push({
            sort: (_a = {},
                _a[key] = key === state.field && state.direction === "asc" ? "desc" : "asc",
                _a),
        });
    };
    return [state, { sortBy: sortBy }];
};
export default useSort;
//# sourceMappingURL=useSort.js.map